import { transparentize } from '../../../../utils/color';
import { asMultiStyleConfig } from '../../../../utils/theme';
export var Footer = asMultiStyleConfig({
  parts: ['mainContainer', 'mainLogoContainer', 'socialIcon', 'divider', 'menuItem', 'legalInfoContainer', 'legalDescription', 'logoLinkStyle', 'menuContainer'],
  baseStyle: {
    mainContainer: {
      pt: {
        base: '2.5rem',
        md: '3rem'
      },
      pb: {
        base: '2.5rem',
        md: '2.5rem'
      },
      backgroundColor: 'blue.700'
    },
    mainLogoContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-end'
    },
    socialIcon: {
      width: '45px',
      height: '45px',
      color: 'blue.700',
      pointerEvents: 'none'
    },
    divider: {
      mt: '2.5rem',
      mb: '2rem',
      borderColor: transparentize('white', 0.2)
    },
    menuContainer: {
      gridTemplateColumns: {
        sm: '19rem',
        md: 'repeat(2, 19rem)',
        mdlg: 'repeat(3, minmax(0px, 19rem))'
      },
      gap: '1.5rem',
      rowGap: '.75rem',
      justifyItems: 'start'
    },
    menuItem: {
      fontSize: '1rem',
      lineHeight: '1.5rem',
      fontWeight: 500,
      color: 'white',
      textUnderlineOffset: '5px',
      _hover: {
        color: 'white',
        textDecoration: 'underline'
      },
      _focus: {
        color: 'blue.275',
        bg: 'blue.1140',
        textDecoration: 'underline'
      }
    },
    legalInfoContainer: {
      '& > div ': {
        alignItems: 'flex-start'
      }
    },
    legalDescription: {
      mb: 0,
      mr: '1rem',
      fontSize: 'sm',
      lineHeight: 'short',
      color: 'white'
    },
    logoLinkStyle: {
      display: 'inline-block',
      _focus: {
        borderRadius: '3px',
        boxShadow: "\n            0 0 0.125rem 0.125rem #00CAFF, \n            0 0 0.125rem 0.125rem #4CAAF0"
      }
    }
  }
});